import { ApiError } from "./error.js";
import { getAuthConfig } from "../config/configStore.js";
/**
 * Create a new user
 * Users API documentation: https://users-svc.playground.internal.distribusion.com/docs#/
 * @param body - User creation request payload
 * @returns User creation response
 */
export const createZitadelUser = async (body) => {
    const { baseUrl, retailerPartnerNumber } = getAuthConfig();
    const response = await fetch(`${baseUrl}/v1/retailers/${retailerPartnerNumber}/users`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
    });
    const parsedResponse = await response.json();
    if (!response.ok) {
        throw new ApiError({
            code: parsedResponse.code || "internalError",
            data: parsedResponse.data || {},
            status: response.status,
            path: new URL(response.url).pathname,
            detail: parsedResponse.detail || {},
        });
    }
    return parsedResponse;
};
/**
 * Fetch current user data
 * Users API documentation: https://users-svc.playground.internal.distribusion.com/docs#/
 * @returns Current user data
 */
export const getCurrentUser = async () => {
    const { baseUrl, retailerPartnerNumber } = getAuthConfig();
    const response = await fetch(`${baseUrl}/v1/retailers/${retailerPartnerNumber}/users/me`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        credentials: "include",
    });
    const parsedResponse = await response.json();
    if (!response.ok) {
        throw new ApiError({
            code: parsedResponse.code || "internalError",
            data: parsedResponse.data || {},
            status: response.status,
            path: new URL(response.url).pathname,
        });
    }
    return parsedResponse;
};
/**
 * Activate user account
 * Users API documentation: https://users-svc.playground.internal.distribusion.com/docs#/
 * @returns Activate user response
 */
export const activateZitadelUser = async (userId, body) => {
    const { baseUrl, retailerPartnerNumber } = getAuthConfig();
    const response = await fetch(`${baseUrl}/v1/retailers/${retailerPartnerNumber}/users/${userId}/activate`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
    });
    const parsedResponse = await response.json();
    if (!response.ok) {
        throw new ApiError({
            code: parsedResponse.code || "internalError",
            data: parsedResponse.data || {},
            status: response.status,
            path: new URL(response.url).pathname,
        });
    }
    return parsedResponse;
};
